export default __webpack_public_path__ + "static/media/convertLightMode.97436c27.svg";